import { hasAnyRoles } from './user-utils';

// Token launch date (start for time based tasks)
export const TOKENS_START_DATE = Date.UTC(2021, 2, 3);

export function tokensEnabled(user) {
  return hasAnyRoles(user, 'admin');
}

export const TOKEN_CREDIT_TASK_CONFIG = {
  custom_credit: { usage: 'unlimited', name: 'Custom Credit', description: 'Tokens awarded by the Wizeprep team' },

  account_created: {
    value: 10,
    usage: 'one_time',
    name: 'Create Wizeprep Account',
    description: 'Create a Wizeprep account.',
    disabled: true,
  },
  account_confirmed: {
    value: 10,
    usage: 'one_time',
    name: 'Confirm Account Email',
    description: 'Confirm your email address.',
    disabled: true,
  },
  account_profile_created: {
    value: 1,
    usage: 'one_time',
    name: 'Add Profile Details',
    description: 'Add your courses to your student profile.',
    disabled: true,
  },
  referral_accepted: {
    value: 5,
    usage: 'unlimited',
    name: 'Invite Friends',
    description: 'Invite a friend to create a Wizeprep account with your unique share URL.',
    disabled: true,
  },
  activities_completed_1: {
    value: 2,
    usage: 'one_time',
    name: 'Heating Up 🔥',
    description: 'Complete 2 Lessons or Practice Questions in your first 3 days on Wizeprep.',
    disabled: true,
    time_limit: 3600 * 24 * 3,
  },
  activities_completed_2: {
    value: 3,
    usage: 'one_time',
    name: 'Hot Start 💥',
    description: 'Complete 6 Lessons or Practice Questions in your first 14 days on Wizeprep.',
    disabled: true,
    time_limit: 3600 * 24 * 14,
  },
  study_session_purchased: {
    value: 10,
    usage: 'unlimited',
    name: 'Purchase a Live Session',
    description: 'Purchase a Live Weekly or Exam Prep Session.',
    disabled: true,
  },
  oc_intro_watched: {
    value: 1,
    usage: 'one_time',
    name: 'Watch Course Introduction',
    description: 'Complete a course intro video.',
    disabled: true,
  },
  quiz_question_answered: {
    value: 1,
    usage: 'one_time',
    name: 'First Correct Question',
    description: "We'll celebrate the first question you get correct.",
    disabled: true,
  },
  lesson_completed: {
    value: 1,
    usage: 'one_time',
    name: 'First Completed Lesson',
    description: "We'll celebrate the first lesson you complete.",
    disabled: true,
  },
  oc_question_reply_upvoted: {
    value: 1,
    usage: 'unlimited',
    name: 'Answer a Community Question',
    description: 'Answer another students question and receive a thumbs up for it.',
    disabled: true,
  },
  dashboard_tour_completed: {
    value: 1,
    usage: 'unlimited',
    name: 'Complete Dashboard Tour',
    description: 'Complete the dashboard tour.',
    disabled: true,
  },
  oc_tour_completed: {
    value: 1,
    usage: 'unlimited',
    name: 'Complete In-Course Tour',
    description: 'Complete the in-course tour.',
    disabled: true,
  },
  course_tip_submitted: {
    value: 1,
    usage: 'unlimited',
    name: 'Course Tip/Trick Submitted',
    description: 'Add a helpful tip or trick for a specific course.',
    disabled: true,
  },
  learning_goal_completed: {
    value: 5,
    usage: 'unlimited',
    name: 'Wizeprep Challenge',
    description: "Up for a challenge? Let's see you complete 10 lessons or practice questions in 5 days.",
    disabled: true,
  },
  account_phone_number_added: {
    value: 2,
    usage: 'one_time',
    name: 'Opt-in for Text Message Reminders',
    description: 'Opt-in to text messages from Wizeprep.',
    disabled: true,
  },
  course_notes_approved: {
    value: 10,
    usage: 'unlimited',
    name: 'Submit Course Notes',
    description: 'Submit a Full Set of Course Notes. Must be approved by Wizeprep.',
    disabled: true,
  },
};
